export default __webpack_public_path__ + "static/media/email-icon.be8da82a.svg";